import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/15 text-primary-400 border border-primary-500/20 mb-3">
            <i className="ri-chat-3-line mr-1"></i>用户心声
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            影迷热评
          </h2>
          <p className="mt-2 text-sm text-foreground-500">来自琪琪影院用户的真实评价</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentItems.map((item) => (
            <div
              key={item.name}
              className="p-5 rounded-xl bg-background-50 border border-background-200/50 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-800">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.date}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed flex-1">{item.content}</p>
              <div className="mt-3 pt-3 border-t border-background-200/50 flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-movie-line text-primary-400"></i>
                <span>在看《{item.film}》</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}